export enum InterventionEventType {
  LIMIT_ORDER,
  BMARK_ORDER,
  FIXING_RATE,
  FILL,
  FWD_FILL_PENDING,
  PORTFOLIO_MANUAL_PRICING,
}

export namespace InterventionEventType {
  let elements = [
    InterventionEventType.LIMIT_ORDER,
    InterventionEventType.BMARK_ORDER,
    InterventionEventType.FIXING_RATE,
    InterventionEventType.FILL,
    InterventionEventType.FWD_FILL_PENDING,
    InterventionEventType.PORTFOLIO_MANUAL_PRICING,
  ];
  let alias = "com.bcdfx.model.InterventionEventType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
